// extracted by mini-css-extract-plugin
export default {"highlight":"battery-details_highlight__OUQam","highlight-desired-level":"battery-details_highlight-desired-level__uruYs"};